import { render, staticRenderFns } from "./CaracterizacionView.vue?vue&type=template&id=2131c290&scoped=true"
import script from "./CaracterizacionView.vue?vue&type=script&lang=js"
export * from "./CaracterizacionView.vue?vue&type=script&lang=js"
import style0 from "./CaracterizacionView.vue?vue&type=style&index=0&id=2131c290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2131c290",
  null
  
)

export default component.exports